import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Grid, Button } from '@material-ui/core';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { withViewport } from '../../util/contextHelpers';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled, manageDisableScrolling } from '../../ducks/UI.duck';
import { getListingsById } from '../../ducks/marketplaceData.duck';
import config from '../../config';
import {
  Page,
  SectionHero,
  ShippingBanner,
  SectionFollowingLanding,
  SectionTrends,
  SectionHowItWorks,
  SectionFeatured,
  SectionLikesHome,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  SuscriptionSection,
  AuthenticationPageModalWrapper,
  HorizontalCarousel,
} from '../../components';

import { TopbarContainer } from '../../containers';
import { loadData, sendEmail, toggleLike } from './LandingPage.duck';
import { queryFavoritedListings, getListingsPage } from '../MyFavoritesPage/MyFavoritesPage.duck';

import facebookImage from '../../assets/default-profile-banner.jpg';
import twitterImage from '../../assets/default-profile-banner.jpg';
import css from './LandingPage.css';
import { upsertSubscriberInSegment } from '../../util/api';
import { logEvent } from '../../util/logsEvent';
import ListingCardAlt from '../../components/ListingCard/ListingCardAlt';
import ImageCard from '../../components/ImageCard/ImageCard';
import Newsletter from '../../components/Newsletter/Newsletter';

const MAX_MOBILE_SCREEN_WIDTH = 768;

export const LandingPageComponent = props => {
  const {
    history,
    intl,
    location,
    onManageDisableScrolling,
    viewport,
    scrollingDisabled,
    currentUser,
    getFavorites,
    getPage,
    isAuthenticated,
    featuredListings,
    currentUserFollowing,
    currentUserFollowingInProgress,
    onSendEmail,
    homePageSections,
    homeSectionsInProgress,
    homeSectionsError,
    likeInProgress,
    onToggleLike,
  } = props;


  //Function to get if someone has accepted the cookies of the site
  function getCookie() {
    if (localStorage.getItem('emailSubscription') === null) {
      localStorage.setItem('emailSubscription', 1);
      return false;
    }
    return true;
  }
  const sendEmail = value => {
    onSendEmail(value)
      .then(() => {
        upsertSubscriberInSegment({ email: value, segmentIds: [process.env.REACT_APP_FLODESK_POPUP_ID] });
        // logEvent('Email Promo Submitted', { email: value.email })
        setOpenEvent(false);
      })
      .catch(() => {
        // Ignore, error handling in duck file
      });
  };

  const [setOpen, setOpenEvent] = useState(false);

  const [showWhatsAppChat, setShowWhatsAppChat] = useState(true);

  const [authContainerOpen, setAuthContainerOpen] = useState(false);

  const openModal = () => {
    const isThereCookies = getCookie();
    if (isAuthenticated === false && isThereCookies === false) {
      setOpenEvent(true);
    }
  };

  const handleWhatsAppClose = () => {
    localStorage.setItem('hideWhatsAppChat', 'true');
    setShowWhatsAppChat(false)
  }

  useEffect(() => {
    async function fetchData() {
      if (!!currentUser && !!currentUser.id) {
        const listings = await getFavorites(currentUser.id.uuid);
        getPage(currentUser.id.uuid, listings, 0);
      }
    }
    fetchData();
  }, [currentUser, getFavorites, getPage]);

  const isMobileLayout = viewport.width < MAX_MOBILE_SCREEN_WIDTH;

  useEffect(() => {
    setTimeout(openModal, 4000);
  }, []);

  const { favoritedListings } = props;


  const handleLoginRequest = (listing) => {
    setAuthContainerOpen(true)
  }

  // Schema for search engines (helps them to understand what this page is about)
  // http://schema.org
  // We are using JSON-LD format
  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'LandingPage.schemaTitle' }, { siteTitle });
  const schemaTitleSub = intl.formatMessage({ id: 'LandingPage.schemaTitleSub' }, { siteTitle });

  const schemaDescription = intl.formatMessage({ id: 'LandingPage.schemaDescription' });
  const schemaImage = `${config.canonicalRootURL}${facebookImage}`;

  const HowItWorksSectionEl = useRef(null);

  const onScrollToEl = () => {
    if (!!HowItWorksSectionEl.current) {
      let element = HowItWorksSectionEl.current;
      let headerOffset = 100;
      var elementPosition = element.getBoundingClientRect().top;
      var offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  const renderSection = (section, index) => {
    const { name, title, items = [], url } = section;

    // Skip rendering if no items and no url
    if (!items?.length && !url) return null;

    let cardComponent;
    if (name === 'featured' || name === 'hotlist') {
      cardComponent = items.map((item, index) => {
        const slug = item.name.toLowerCase().replace(/\s+/g, '-');
        return (
          <div 
            key={item.id || index}
            style={{ cursor: 'pointer' }}
          >
            <ListingCardAlt 
              listing={{
                ...item,
                urlSeller: item.urlSeller || '',
                brandUrl: item.brandUrl || '',
                sellerProfileImage: item.sellerProfileImage || '',
                likes: item.likes || 0,
                likedBy: item.likedBy || []
              }}
              intl={intl}
              handleLoginRequest={handleLoginRequest}
              likeInProgress={likeInProgress}
              currentUser={currentUser}
              onToggleLike={onToggleLike}
            />
          </div>
        );
      });
    } else {
      cardComponent = items.map((item, index) => (
        <ImageCard 
          key={item.name || index}
          item={item}
          sectionName={name}
        />
      ));
    }

    return (
      <React.Fragment key={name}>
        <div className={css.section}>
          <div className={css.sectionHeader}>
            <h2 className={css.sectionTitle}>{title}</h2>
            {url && !isMobileLayout && (
              <Button 
                className={css.viewAllButton}
                onClick={() => {
                  window.location.href = url;
                }}
              >
                Ver todas
              </Button>
            )}
          </div>
          <HorizontalCarousel>
            {cardComponent}
          </HorizontalCarousel>
          {url && isMobileLayout && (
            <Button 
              className={css.viewAllButton}
              onClick={() => {
                window.location.href = url;
              }}
            >
              Ver todas
            </Button>
          )}
        </div>

        {/* Add sell banner after third section */}
        {index === 2 && (
          <div className={css.sellBanner}>
            <h2 className={css.sellBannerTitle}>¡Que tu clóset se convierta en ganancias!</h2>
            <Button 
              className={css.sellButton}
              onClick={() => {
                if (isAuthenticated) {
                  history.push('/l/draft/00000000-0000-0000-0000-000000000000/new/edit');
                } else {
                  setAuthContainerOpen(true);
                  localStorage.setItem('redirectAfterAuth', '/l/draft/00000000-0000-0000-0000-000000000000/new/edit');
                }
              }}
            >
              <span>Vende hoy!</span>
            </Button>
          </div>
        )}

        {/* Add newsletter after last section */}
        {index === homePageSections.length - 1 && (
          <Newsletter onSendEmail={sendEmail} />
        )}
      </React.Fragment>
    );
  };

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={!!currentUser ? schemaTitleSub : schemaTitle}
      facebookImages={[{ url: facebookImage, width: 1200, height: 630 }]}
      twitterImages={[
        { url: `${config.canonicalRootURL}${twitterImage}`, width: 600, height: 314 },
      ]}
      listing
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: !!currentUser ? schemaTitleSub : schemaTitle,
        image: [schemaImage],
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          {isAuthenticated ? (
            <ShippingBanner
              message="¿Primera compra? Usa el código HOLAGLOSET y obtén $150"
              link={'https://gloset.mx/s?hotlist=true&featured=true&sort=-pub_updatedAt'}
            />
          ) : (
            <ShippingBanner
              message="¿Primera compra? Usa el código HOLAGLOSET y obtén $150"
              link={'https://invita.gloset.mx/iKHiFeqCbJ67YWf26'}
            />
          )}
          <TopbarContainer />
          <nav className={css.mobileCategoryNav}>
            <ul className={css.categoryList}>
              <li>
                <a href="/s?hotlist=true" className={css.categoryItem}>
                  Hot list
                </a>
              </li>
              <li>
                <a href="/s?collectionName=lo_mas_nuevo" className={css.categoryItem}>
                  Lo mas nuevo
                </a>
              </li>
              <li>
                <a href="/s?pub_category=Vestidos&track=Vestidos%20formales" className={css.categoryItem}>
                  Vestidos formales
                </a>
              </li>
            </ul>
          </nav>
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <SectionHero isAuthenticated={isAuthenticated} scrollHandler={onScrollToEl} />
          {homeSectionsInProgress ? (
            <div>Loading...</div>
          ) : Array.isArray(homePageSections) ? (
            homePageSections.map((section, index) => renderSection(section, index))
          ) : null}
          
          <AuthenticationPageModalWrapper
            authContainerOpen={authContainerOpen}
            closeAuthModal={() => {
              setAuthContainerOpen(false);
              
              // Check if we need to redirect after auth
              if (isAuthenticated) {
                const redirectPath = localStorage.getItem('redirectAfterAuth');
                if (redirectPath) {
                  localStorage.removeItem('redirectAfterAuth');
                  history.push(redirectPath);
                }
              }
            }}
          />
          
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

const { bool, object, arrayOf, func } = PropTypes;

LandingPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  favoritedListings: arrayOf(PropTypes.listing).isRequired,
  // from withRouter
  history: object.isRequired,
  location: object.isRequired,
  onManageDisableScrolling: func.isRequired,
  onSendEmail: func.isRequired,
  onToggleLike: func.isRequired,
  // from injectIntl
  intl: intlShape.isRequired,
  homePageSections: arrayOf(object).isRequired,
  homeSectionsInProgress: bool.isRequired,
  homeSectionsError: object,
};

const mapStateToProps = state => {
  const { currentUser, currentUserFollowing, currentUserFollowingInProgress } = state.user;
  const { isAuthenticated } = state.Auth;
  const { 
    featuredListingsIds,
    homePageSections,
    homeSectionsInProgress,
    homeSectionsError,
  } = state.LandingPage;
  const { favoritedListingsIds } = state.MyFavoritesPage;
  const { likeInProgress } = state.ListingPage;

  const pageListings = getListingsById(state, featuredListingsIds, 'pageListings');
  const listings = getListingsById(state, favoritedListingsIds, 'listings');
  const usersIds = currentUserFollowing.map(i => ({ id: i, type: 'user' }));
  const followingUsers = getMarketplaceEntities(state, usersIds) || [];

  return {
    featuredListings: pageListings,
    favoritedListings: listings,
    isAuthenticated,
    currentUser,
    currentUserFollowing: followingUsers,
    currentUserFollowingInProgress,
    scrollingDisabled: isScrollingDisabled(state),
    homePageSections,
    homeSectionsInProgress,
    homeSectionsError,
    likeInProgress,
  };
};

const mapDispatchToProps = dispatch => ({
  getFavorites: user => dispatch(queryFavoritedListings(user)),
  getPage: (user, listings, page) => dispatch(getListingsPage(user, listings, page)),
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onSendEmail: email => dispatch(sendEmail(email)),
  onToggleLike: (user, listingId) => dispatch(toggleLike(user, listingId)),
});
// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const LandingPage = compose(
  withRouter,
  withViewport,
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(LandingPageComponent);

LandingPage.loadData = () => {
  return loadData();
};

export default LandingPage;
